import React, { useEffect, useState } from "react";
import "./Faq.css";
import Button from "../../../components/reusable-button/Button";
import ReusableAccordion from "../../../components/reusable-accordian/ReusableAccordion";
import FaqModal, { FaqFormData } from "./faq-modal/FaqModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../../redux/store/store";
import {
  fetchFaqs,
  addFaq,
  editFaq,
  setFaqRefresh,
} from "../../../redux/slices/faqSlice";
import { showSnackbar } from "../../../redux/slices/snackbarSlice";
import ReusableLoader from "../../../components/reusable-loader/ReusableLoader";

const Faq: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    data: faqs,
    loading,
    error,
    needRefresh,
  } = useSelector((state: RootState) => state.faq);
  const [faqModalOpen, setFaqModalOpen] = useState(false);
  const [faqModalMode, setFaqModalMode] = useState<"add" | "edit">("add");
  const [faqEditData, setFaqEditData] = useState<FaqFormData | undefined>();
  const [isLoading, setIsLoading] = useState(false);

  const adminDetail = localStorage.getItem("adminDetail");
  const roleName = adminDetail
    ? JSON.parse(adminDetail)?.roleIds?.roleName
    : null;

  useEffect(() => {
    if (needRefresh) {
      dispatch(fetchFaqs());
    }
  }, [dispatch, needRefresh]);

  const handleSave = async (form: FaqFormData) => {
    if (!form.question || !form.answer) {
      dispatch(
        showSnackbar({
          message: "Question and Answer are required",
          type: "error",
        })
      );
      return;
    }
    setIsLoading(true);
    try {
      if (faqModalMode === "add") {
        await dispatch(addFaq(form)).unwrap();
        dispatch(
          showSnackbar({ message: "FAQ added successfully", type: "success" })
        );
      } else if (faqModalMode === "edit" && faqEditData?.id) {
        await dispatch(editFaq({ id: faqEditData.id, form })).unwrap();
        dispatch(
          showSnackbar({ message: "FAQ updated successfully", type: "success" })
        );
      }
      // Refresh the data after save
      dispatch(setFaqRefresh(true));
    } catch (err) {
      dispatch(
        showSnackbar({
          message: (err as string) || "Something went wrong",
          type: "error",
        })
      );
    } finally {
      setFaqModalOpen(false);
      setIsLoading(false);
    }
  };

  return (
    <div className="faq-page">
      <div className="faq-header">
        <h2>Frequently Asked Questions ({faqs?.length})</h2>
        {roleName !== "admin" && (
          <div>
            <Button
              label="+ Add FAQs"
              onClick={() => {
                setFaqModalMode("add");
                setFaqEditData(undefined);
                setFaqModalOpen(true);
              }}
            />
          </div>
        )}
      </div>

      {loading && <ReusableLoader />}
      {error && <p className="error">⚠️ {error}</p>}

      {!loading &&
        !error &&
        faqs.map(({ id, assistanceQuestion, assistanceAnswer, isActive }) => (
          <ReusableAccordion
            key={id}
            title={assistanceQuestion}
            {...(roleName !== "admin" && {
              onEdit: () => {
                setFaqModalMode("edit");
                setFaqEditData({
                  id,
                  question: assistanceQuestion,
                  answer: assistanceAnswer,
                  active: isActive,
                });
                setFaqModalOpen(true);
              },
            })}
            status={isActive ? "Active" : "Inactive"}
            showStatus={true}
          >
            <p dangerouslySetInnerHTML={{ __html: assistanceAnswer }} />
          </ReusableAccordion>
        ))}

      <FaqModal
        isOpen={faqModalOpen}
        mode={faqModalMode}
        initialData={faqEditData}
        onClose={() => setFaqModalOpen(false)}
        onSave={handleSave}
        loading={isLoading}
      />
    </div>
  );
};

export default Faq;
